// action type
const SET_PENDING_ACTION = "SET_PENDING_ACTION";
const SET_MODIFIED_TIME = "SET_MODIFIED_TIME";
const SET_EXECUTE_PENDING_ACTION = "SET_EXECUTE_PENDING_ACTION";
const SET_PROCEDURE_ID = "SET_PROCEDURE_ID";

const PendingActionTypes = {
  ProcedureFilesEdit: "ProcedureFilesEdit",
  ProcedureFilesEditSubmit: "ProcedureFilesEditSubmit",
  ProcedureFilesCoverSheet: "ProcedureFilesCoverSheet",
  ProcedureFilesApplyForJB: "ProcedureFilesApplyForJB",
  ProcedureFilesTLReview: "ProcedureFilesTLReview",
  SupportingFilesEdit: "SupportingFilesEdit",
  ProcedureInfoEdit: "ProcedureInfoEdit",
  SharedTasksEdit: "SharedTasksEdit",
  SharedTasksChangeMainTask: "SharedTasksChangeMainTask",
  SharedTasksManageSharedTask: "SharedTasksManageSharedTask",
};

export {
  SET_PENDING_ACTION,
  SET_MODIFIED_TIME,
  SET_EXECUTE_PENDING_ACTION,
  SET_PROCEDURE_ID,
  PendingActionTypes,
};
